// client/util.ts
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { render } from "lit";
import { NodeSelection } from "prosemirror-state";
function isMarkActive(state, type) {
  const { from, $from, to, empty } = state.selection;
  if (empty)
    return !!type.isInSet(state.storedMarks ?? $from.marks());
  else
    return state.doc.rangeHasMark(from, to, type);
}
function createHTMLElementByTemplate(template) {
  return createElementByTemplate(xComponents(template));
}
function createElementByTemplate(template) {
  const docFragment = new DocumentFragment();
  render(template, docFragment);
  const element = docFragment.firstElementChild;
  if (!element)
    throw new Error("element not found");
  return element;
}
function toDOMByTemplate(template) {
  const element = createElementByTemplate(template);
  return { dom: element, contentDOM: element };
}
function getSiblingsOfElement(element) {
  const siblings = [];
  if (!element.parentNode) {
    return siblings;
  }
  let sibling = element.parentNode.firstElementChild;
  while (sibling) {
    if (sibling !== element) {
      siblings.push(sibling);
    }
    sibling = sibling.nextElementSibling;
  }
  return siblings;
}
function isNodeSelection(selection) {
  return selection instanceof NodeSelection;
}
function updateNodeAttrs(state, transaction, getPos, newAttrs) {
  const pos = getPos();
  const node = state.doc.nodeAt(pos);
  if (!node)
    return transaction;
  const updatedNode = node.type.create(
    { ...node.attrs, ...newAttrs },
    // Merge bestehende attrs mit den neuen
    node.content,
    // Behalte den Inhalt bei
    node.marks
    // Behalte vorhandene Marks bei
  );
  transaction.replaceWith(pos, pos + node.nodeSize, updatedNode);
  return transaction;
}
function getNodeBySelection(state) {
  const { selection } = state;
  const { $from } = selection;
  if (selection instanceof NodeSelection)
    return selection.node;
  return $from.node();
}
function getCursorNodeType(state) {
  return getNodeBySelection(state).type.name;
}
function isInParagraph(state) {
  return getCursorNodeType(state) === "paragraph";
}
function isInHeading(state) {
  return getCursorNodeType(state) === "heading";
}
function isInText(state) {
  return isInParagraph(state) || isInHeading(state);
}
export {
  createElementByTemplate,
  createHTMLElementByTemplate,
  getCursorNodeType,
  getNodeBySelection,
  getSiblingsOfElement,
  isInHeading,
  isInParagraph,
  isInText,
  isMarkActive,
  isNodeSelection,
  toDOMByTemplate,
  updateNodeAttrs
};
